import { connect } from 'react-redux';
import Global from '../../../store/global-selectors';
import { selectOrderDetailsInventoryInfo } from '../../../store/orders/order-details/orders.details.selectors';
import { selectOrdersDrawerSingleOrderInventoryInfo } from '../../../store/orders/drawer/orders.drawer.selectors';
import { InventoryService } from '../../../services/inventory-service';
import { InventoryItemStockCount } from './inventory-stock-count.component';

const decideIfShouldBeHidden = (state, isInOrdersDrawer, fulfillmentPlanId) => {
  const numberOfSelectedOrders = Global.selectSelectedOrdersCount(state);
  if (numberOfSelectedOrders > 1) {
    return true;
  }

  return !InventoryService.shouldItemInventoryInformationShow(state, fulfillmentPlanId, isInOrdersDrawer);
};

const mapStateToProps = (state, props) => {
  const { orderItem, isInOrdersDrawer, fulfillmentPlanId } = props;

  const shouldBeHidden = decideIfShouldBeHidden(state, isInOrdersDrawer, fulfillmentPlanId);
  if (shouldBeHidden) {
    return {
      shouldBeHidden,
    };
  }

  const inventoryInfo = isInOrdersDrawer
    ? selectOrdersDrawerSingleOrderInventoryInfo(state) || {}
    : selectOrderDetailsInventoryInfo(state) || {};
  const { isLoading = false } = inventoryInfo;

  const inventoryStockLevels =
    inventoryInfo && inventoryInfo.stockLevelInfo
      ? inventoryInfo.stockLevelInfo.reduce((accumulator, { stockLevels, fulfillmentPlanItemId }) => {
          const isStockLevelInfoAssociatedToOrderItem = `${fulfillmentPlanItemId}` === orderItem.fulfillmentPlanItemId;
          if (isStockLevelInfoAssociatedToOrderItem) {
            return [...accumulator, ...stockLevels];
          }
          return accumulator;
        }, [])
      : [];

  return {
    inventoryStockLevels,
    doesInventorySourceSupportAllocation: InventoryService.canFulfillmentPlanBeAllocated(state, fulfillmentPlanId, isInOrdersDrawer),
    isAllocatable: InventoryService.canItemBeAllocated(state, isInOrdersDrawer, fulfillmentPlanId, orderItem),
    isAllocated: InventoryService.isItemAllocated(state, isInOrdersDrawer, fulfillmentPlanId, orderItem),
    isLoading,
  };
};

export const InventoryStockCountContainer = connect(mapStateToProps)(InventoryItemStockCount);
